<div class="container" *ngIf=true>
  <div id="home_nav" class="row">
      <div class="col-md-12">
          <ol class="breadcrumb forgotpwdMenu">
              <li class="breadcrumb-item">
                  <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home</a>
              </li>
              <li class="breadcrumb-item active" >
                {{forgotPwdTitle}}
              </li>
          </ol>
      </div>
  </div>
  <div class="row justify-content-md-center" [ngClass]="{'forgotpwdpanel ': !resetPwdSuccess, 'forgotpwdpanelSucess':resetPwdSuccess}">
      <div [ngClass]="{'col-md-4 ': !resetPwdSuccess, 'col-md-6':resetPwdSuccess}" class="col-md-offset-4 lg-signBoxDiv">
          <div class="card forgotpwd-card">
              <div class="card-header forgotpwd-card-header">{{forgotPwdTitle}}</div>
              <div class="card-body forgotpwd-card-body" *ngIf="!resetPwdSuccess">
                  <form  (ngSubmit)="!forgotpwdForm.invalid && forgotPasswordReset()" #forgotpwdForm="ngForm">
                      <fieldset class="form-group">
                          <div>
                              <label *ngIf="emailAuthentic" for="username">{{forgotPwdLabelConfig.resetPwdFindSimsUserLabel}}</label>
                              <label *ngIf="!emailAuthentic" for="username">Email:</label>
                              <div class="input-group mb-3">
                                      <span class="input-group-text"><i class="fa fa-user"></i></span>
                              <input type="text" #username="ngModel" [(ngModel)]="model.username" class="input form-control" id="username" name="username" 
                              required="required" minlength="1" (click)=closeAlert()>
                              </div>
                          </div>
                      </fieldset>
                      <div class="row">
                          <div class="col-sm-12 text-right d-flex justify-content-end">
                              <button type="submit button" class="btn btn-xs btn-light forgotpwd-btn" [disabled]="forgotpwdForm.invalid">Submit</button>
                          </div>
                      </div>
                      <div>
                          <br>
                    <div class="alert-danger alertfailMessage" *ngIf="resetPwdIsFailed">
                        <div id="title" style="text-align:center;">
                          </div><br>
                        <div  [innerHTML]="resetEmailFailureMsg"><b>{{resetEmailFailureMsg}}</b></div>
                      </div>
                      </div> 
                  </form>
              </div>
              <div></div>
              <div class="card-body forgotpwd-card-body alert alert-pwdResetSuccess alertPwdResetMessage" *ngIf="resetPwdSuccess">
                <div id="title" style="text-align:center;">
                  <b>{{resetEmailSuccessMsg}}</b></div>
                  <br>
                <div style="width: 105%;" [innerHTML]="resetSuccesMsg"></div>
              </div>
          </div>
      </div>
  </div>
</div>